/**
 * Detect if the page is running inside an in-app browser / WebView
 * where Google blocks OAuth (Error 403: disallowed_useragent).
 */
export function isInAppBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  // Common in-app browser User-Agent fragments
  const patterns = [
    "FBAN",
    "FBAV",
    "FB_IAB",
    "FBIOS",
    "Instagram",
    "Twitter",
    "TwitterAndroid",
    "Line/",
    "MicroMessenger", // WeChat
    "Snapchat",
    "TikTok",
    "musical_ly",
    "Pinterest",
    "Linkedin",
    "LinkedInApp",
    "WhatsApp",
    "Messenger",
    "OKApp",
    "Reddit",
    "GSA/", // Google App
  ];
  for (const p of patterns) {
    if (ua.indexOf(p) !== -1) return true;
  }
  // iOS WebViews: Safari has "Safari" in UA, in-app webviews don't
  const isIOS = /iPhone|iPad|iPod/.test(ua);
  const hasSafari = / Safari\//.test(ua);
  const isStandaloneApp =
    typeof window !== "undefined" &&
    (window.navigator.standalone === true || window.matchMedia?.("(display-mode: standalone)").matches);
  if (isIOS && !hasSafari && !isStandaloneApp) return true;

  // Android WebView: contains "; wv)" segment
  if (/Android/.test(ua) && /; wv\)/.test(ua)) return true;

  return false;
}
